import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
// api
import ApiKey from '../../api/ApiKey';
import BaseApi from '../../api/BaseApi';
// components
import APNavBar from '../Elements/APNavBar';
import APSidebar from '../APSidebar/APSidebar';
// mui
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const APAddNewSeoInfo = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const tokenKey = Cookies.get('token');
  const adminID = Cookies.get('adminID');

  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({
    title: '',
    seo_slug: '',
    seo_text: '',
    description: '',
    seo_preview: '',
  });
  const [errors, setErrors] = useState({
    title: '',
    seo_slug: '',
    seo_text: '',
    description: '',
    seo_preview: '',
  });

  const getData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        BaseApi + `/admin/meta/${id}`,
        {
          headers: {
            key: ApiKey,
            adminid: adminID,
            ContentType: 'application/json',
            Authorization: `Bearer ${tokenKey}`,
          },
        },
      );
      setLoading(false);
      setUserData(response.data);
    } catch (error) {
      console.error('Error', error);
    }
  };

  const handleChange = e => {
    const { name, value } = e.target;

    setUserData(prev => ({
      ...prev,
      [name]: value,
    }));

    setErrors(prev => ({
      ...prev,
      [name]: '',
    }));
  };

  const handleClick = async e => {
    e.preventDefault();

    try {
      const newErrors = {};

      if (userData.title === '') {
        newErrors.title = 'Title is required';
      }
      if (userData.seo_slug === '') {
        newErrors.seo_slug = 'URL is required';
      }
      if (userData.description === '') {
        newErrors.description = 'Description is required';
      }
      // if (userData.seo_text === '') {
      //   newErrors.seo_text = 'Remaining SEO Text is required';
      // }
      // if (userData.seo_preview === '') {
      //   newErrors.seo_preview = 'Preview SEO Text is required';
      // }

      setErrors(newErrors);

      if (Object.keys(newErrors).length === 0) {
        const confirmationResult = await Swal.fire({
          icon: 'question',
          cancelButtonText: 'No',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          title: id ? 'Update?' : 'Create?',
          text: id ? 'Do you want to update SEO Info?' : 'Do you want to create SEO Info?',
        });

        if (confirmationResult.isConfirmed) {
          setLoading(true);

          if (id) {
            const response = await axios.put(
              BaseApi + `/admin/meta/${id}`,
              userData,
              {
                headers: {
                  key: ApiKey,
                  adminid: adminID,
                  ContentType: 'application/json',
                  Authorization: `Bearer ${tokenKey}`,
                },
              },
            );

            setLoading(false);

            if (response.status === 200) {
              Swal.fire({
                icon: 'success',
                confirmButtonText: 'Close',
                title: 'SEO Info updated successfully!',
              });

              navigate('/admin/seo-list');
            } else {
              Swal.fire({
                icon: 'error',
                confirmButtonText: 'Close',
                title: response.data.message,
              });
            }
          } else {
            const response = await axios.post(
              BaseApi + '/admin/meta/create',
              userData,
              {
                headers: {
                  key: ApiKey,
                  adminid: adminID,
                  ContentType: 'application/json',
                  Authorization: `Bearer ${tokenKey}`,
                },
              },
            );

            setLoading(false);

            if (response.status === 200) {
              Swal.fire({
                icon: 'success',
                confirmButtonText: 'Close',
                title: 'SEO Info created successfully!',
              });

              navigate('/admin/seo-list');
            } else {
              Swal.fire({
                icon: 'error',
                confirmButtonText: 'Close',
                title: response.data.message,
              });
            }
          }
        }
      }
    } catch (error) {
      setLoading(false);

      Swal.fire({
        icon: 'error',
        title: 'Failed',
        confirmButtonText: 'Close',
        text: 'Could not create SEO Info. Please try again later!',
      });

      console.error('Could not create SEO Info!', error);
    }
  };

  useEffect(() => {
    if (!tokenKey) {
      navigate('/admin');
    } else {
      if (id) {
        getData();
      }

      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate]); // eslint-disable-line

  return (
    <>
      <APNavBar />
      <div className='APBasic'>
        <APSidebar />
        {
          loading
            ? (
              <div className='loader-container' />
            ) : (
              <div className='site-min-height'>
                <div className='breadCumb1' role='presentation'>
                  <Breadcrumbs
                    aria-label='breadcrumb'
                    separator={<NavigateNextIcon fontSize='small' />}
                  >
                    <Link
                      color='inherit'
                      underline='hover'
                      style={{ cursor: 'pointer' }}
                      onClick={() => navigate('/admin/admins/dashboard')}
                    >
                      Dashboard
                    </Link>
                    <Link
                      color='inherit'
                      underline='hover'
                      style={{ cursor: 'pointer' }}
                      onClick={() => navigate('/admin/seo-list')}
                    >
                      SEO List
                    </Link>
                    <Typography color='text.primary'>
                      {
                        id
                          ? 'Edit SEO Info'
                          : 'Add New SEO Info'
                      }
                    </Typography>
                  </Breadcrumbs>
                </div>
                <h2 className='adminPageHeading'>
                  {
                    id
                      ? 'Edit SEO Info'
                      : 'Add New SEO Info'
                  }
                </h2>
                <form className='adminForm' onSubmit={e => handleClick(e)}>
                  <div className='mb-4 mt-5'>
                    <div className='mb-5 DashBoardInputBx'>
                      <label htmlFor='formFile' className='form-label'>
                        URL (e.g. /searchjob/c-management)
                        <span className='RedStar'>*</span>
                      </label>
                      <input
                        type='text'
                        id='seo_slug'
                        name='seo_slug'
                        onChange={handleChange}
                        value={userData.seo_slug}
                        placeholder='/searchjob/c-management'
                        className={`form-control ${errors.seo_slug && 'input-error'}`}
                      />
                      {
                        errors.seo_slug && (
                          <div className='text-danger'>
                            {errors.seo_slug}
                          </div>
                        )
                      }
                    </div>
                    <div className='mb-5 DashBoardInputBx'>
                      <label htmlFor='formFile' className='form-label'>
                        Meta Title
                        <span className='RedStar'>*</span>
                      </label>
                      <input
                        id='title'
                        type='text'
                        name='title'
                        value={userData.title}
                        onChange={handleChange}
                        placeholder='Meta Title'
                        className={`form-control ${errors.title && 'input-error'}`}
                      />
                      {
                        errors.title && (
                          <div className='text-danger'>
                            {errors.title}
                          </div>
                        )
                      }
                    </div>
                    <div className='mb-5 DashBoardInputBx'>
                      <label htmlFor='formFile' className='form-label'>
                        Meta Description
                        <span className='RedStar'>*</span>
                      </label>
                      <input
                        type='text'
                        id='description'
                        name='description'
                        onChange={handleChange}
                        value={userData.description}
                        placeholder='Meta Description'
                        className={`form-control ${errors.description && 'input-error'}`}
                      />
                      {
                        errors.description && (
                          <div className='text-danger'>
                            {errors.description}
                          </div>
                        )
                      }
                    </div>
                    <div className='mb-5 DashBoardInputBx'>
                      <label htmlFor='formFile' className='form-label'>
                        SEO Text Preview
                      </label>
                      <textarea
                        rows={5}
                        id='seo_preview'
                        name='seo_preview'
                        onChange={handleChange}
                        value={userData.seo_preview}
                        placeholder='Enter short preview SEO Text with HTML tags'
                        className={`form-control ${errors.seo_preview && 'input-error'}`}
                      />
                      {
                        errors.seo_preview && (
                          <div className='text-danger'>
                            {errors.seo_preview}
                          </div>
                        )
                      }
                    </div>
                    <div className='mb-5 DashBoardInputBx'>
                      <label htmlFor='formFile' className='form-label'>
                        Remaining SEO Text
                      </label>
                      <textarea
                        rows={10}
                        id='seo_text'
                        name='seo_text'
                        onChange={handleChange}
                        value={userData.seo_text}
                        placeholder='Enter remaining SEO Text with HTML tags'
                        className={`form-control ${errors.seo_text && 'input-error'}`}
                      />
                      {
                        errors.seo_text && (
                          <div className='text-danger'>
                            {errors.seo_text}
                          </div>
                        )
                      }
                    </div>
                    <div className='adminBottomButtons'>
                      <button
                        type='submit'
                        className='btn btn-primary button1'
                      >
                        {
                          id
                            ? 'Update'
                            : 'Create'
                        }
                      </button>
                      <button
                        type='button'
                        className='btn btn-primary button2'
                        onClick={() => navigate('/admin/seo-list')}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            )}
      </div>
    </>
  );
};

export default APAddNewSeoInfo;
